import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Constants from '../../utils/constants';
import { authHeader } from '../../utils/headers';

// Dérive la base API à partir d'une URL constante (même pattern que les autres *Api du projet)
function getApiBase() {
    try {
        const u = new URL(Constants.API_ROUTE_CLIENTS);
        return `${u.protocol}//${u.host}`;
    } catch (e) {
        return import.meta.env.VITE_APIURL || '';
    }
}

// Extrait le path (sans host) d'une URL absolue
function toPath(url) {
    try {
        const u = new URL(url);
        return u.pathname + u.search;
    } catch (e) {
        return url;
    }
}

export const clientsApi = createApi({
    reducerPath: 'clientsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getApiBase(),
        prepareHeaders: (headers) => {
            const token = authHeader();
            if (typeof token === 'string' && token) {
                headers.set('authorization', token);
            }
            return headers;
        },
    }),
    tagTypes: ['Client'],
    endpoints: (builder) => ({
        // GET /api/clients -> retourne directement hydra:member
        getClients: builder.query({
            query: () => toPath(Constants.API_ROUTE_CLIENTS),
            transformResponse: (response) => {
                if (response && Array.isArray(response['hydra:member'])) {
                    return response['hydra:member'];
                }
                return Array.isArray(response) ? response : [];
            },
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({ type: 'Client', id })),
                        { type: 'Client', id: 'LIST' },
                    ]
                    : [{ type: 'Client', id: 'LIST' }],
        }),
    }),
});

export const { useGetClientsQuery, useLazyGetClientsQuery } = clientsApi;
